import {
  PromotionalBanner,
  useTranslation,
  Drawer,
  Button,
  ButtonSize,
  ButtonWidth,
  PromotionalMessageTextSize,
  PromotionalMessageType,
} from '@nextgen-web-framework/all';
import { formatDate } from '@commerce-promotion-webcomponents/sdk';
import type { PromotionDetailsListProps } from './types/propsTypes';
import styles from './PromotionDetailsList.module.scss';

export const PromotionDetailsList = ({
  firedPromotions,
  potentialPromotions,
  couponVariant,
  orderPageVariant,
  closeDrawer,
}: PromotionDetailsListProps) => {
  const t = useTranslation();
  const offerEndsText = t('promotion.promotionDetailsList.offerEnds');
  const headerTitle = orderPageVariant
    ? t(couponVariant ? 'promotion.promotionDetailsList.coupons' : 'promotion.promotionDetailsList.promotions')
    : t('promotion.promotionDetailsList.promoDetailsText');

  const sections = [
    {
      promotionType: PromotionalMessageType.APPLIED,
      title: t('promotion.promotionDetailsList.promotionsAppliedText'),
      items: firedPromotions,
    },
    {
      promotionType: PromotionalMessageType.POTENTIAL,
      title: t('promotion.promotionDetailsList.promotionsAvailableText'),
      items: potentialPromotions,
    },
  ];

  return (
    <div className={styles['PromotionDetailsList']} data-testid="promotion-details-drawer-component">
      <Drawer
        bottomGap={0}
        header={<span data-testid="promo-drawer-title">{headerTitle}</span>}
        footer={
          !orderPageVariant && (
            <div className={styles['PromotionDetailsList-footer-btn']}>
              <Button
                title={t('promotion.promotionDetailsList.done')}
                size={ButtonSize.SMALL}
                buttonWidth={ButtonWidth.FULL_WIDTH}
                onClick={closeDrawer}
                data-testid="PromotionDetailsList-footer-btn"
              />
            </div>
          )
        }
        closeIcon
        closeOnBackdropClick
        onClose={closeDrawer}
      >
        <div className={styles['PromotionDetailsList-body']}>
          {sections.map(
            ({ items, promotionType, title }) =>
              Boolean(items?.length) && (
                <div
                  key={promotionType}
                  className={styles['PromotionDetailsList-body-promo']}
                  id={`${promotionType.toLocaleLowerCase()}-promos`}
                >
                  <div className={styles['PromotionDetailsList-body-promo-text']}>
                    {title.replace('{{text}}', String(items?.length))}
                  </div>
                  <div className={styles['PromotionDetailsList-body-main-promo']}>
                    {items?.map(({ promotion }) => (
                      <PromotionalBanner
                        key={promotion?.code}
                        isExpanded
                        promotionType={promotionType}
                        iconName={couponVariant ? 'ticket' : 'tags'}
                        promotionTitleText={promotion?.name ?? ''}
                        size={PromotionalMessageTextSize.LARGE}
                        {...(!orderPageVariant && {
                          promotionlDescription: promotion?.message,
                          promotionEndText:
                            promotion?.endDate && `${offerEndsText} ${formatDate(promotion?.endDate, true)}`,
                        })}
                      />
                    ))}
                  </div>
                </div>
              ),
          )}
        </div>
      </Drawer>
    </div>
  );
};
